import React, { useState } from "react";
import { DataFileTypeModel, getDataFileTypeLabel } from "../api/vehicleFileAPI";
import { Col, ListGroup, ListGroupItem, Row, Tab } from "react-bootstrap";
import { Folder, Folder2Open } from "react-bootstrap-icons";
import DataFilesCrumbs from "./DataFilesCrumbs";
import { DataFileEntry } from "../common/fileUtils";

interface DataFilesDirectoryViewProps {
  files: DataFileEntry[][];
  types: DataFileTypeModel[];
  disabled: boolean;
  onView: (fullPath: string, type: DataFileTypeModel) => void;
  onViewNewTab: (fullPath: string, type: DataFileTypeModel) => void;
  onDownload: (fullPath: string, type: DataFileTypeModel) => void;
  onDelete: (fullPath: string, type: DataFileTypeModel) => void;
  onAdd: (fullPath: string, type: DataFileTypeModel) => void;
}

export function DataFilesDirectoryView({
  files,
  types,
  disabled,
  onView,
  onViewNewTab,
  onDownload,
  onDelete,
  onAdd,
}: DataFilesDirectoryViewProps) {
  const [selectedIndex, setSelectedIndex] = useState(0);

  return (
    <Tab.Container defaultActiveKey={0} activeKey={selectedIndex}>
      <Row>
        <Col sm="auto">
          <ListGroup>
            {types.map((type, index) => (
              <ListGroupItem
                variant="secondary"
                action
                onClick={() => setSelectedIndex(index)}
                eventKey={index}
              >
                {selectedIndex === index ? <Folder2Open /> : <Folder />}{" "}
                {getDataFileTypeLabel(type)}
              </ListGroupItem>
            ))}
          </ListGroup>
        </Col>
        <Col>
          <Tab.Content>
            {types.map((type, index) => (
              <Tab.Pane eventKey={index}>
                <DataFilesCrumbs
                  files={files[index]}
                  disabled={disabled}
                  rootName={getDataFileTypeLabel(type)}
                  onView={(path) => onView(path, type)}
                  onViewNewTab={(path) => onViewNewTab(path, type)}
                  onDownload={(path) => onDownload(path, type)}
                  onDelete={(path) => onDelete(path, type)}
                  onAdd={(path) => onAdd(path, type)}
                />
              </Tab.Pane>
            ))}
          </Tab.Content>
        </Col>
      </Row>
    </Tab.Container>
  );
}

export default DataFilesDirectoryView;
